import { Component, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '../service/theme.service';
import { DistributorsService } from '../service/distributors.service';
import { CognitoService } from '../service/cognito.service';
import { RoleService } from '../service/role.service';
import { WorkOrderDashboardModalService } from '../service/work-order-dashboard-modal.service';
import { SystemMessageService } from '../service/system-message.service';
import { environment } from '../environments/environment';
import { LocalStorageService } from '../local-storage.service';
import { FilterService } from '../service/filter.service';
import { WorkOrderService } from '../service/work-order.service';
import { WorkOrderStatus } from '../constants/work-order-status';
import { WorkOrderTypes } from '../constants/work-order-types'

@Component({
    selector: 'app-client-work-order-dashboard',
    templateUrl: './client-work-order-dashboard.component.html',
    styleUrls: ['./client-work-order-dashboard.component.css', '../../global-elements.css'],
    standalone: false
})
export class ClientWorkOrderDashboardComponent implements OnInit {
  @ViewChild(WorkOrderDashboardModalService) service: any;

  public isLoading: boolean = true;
  public ascDesc: number = 0;
  public sortBy: string = '';

  public workOrderArray: any[] = [];
  private originalWorkOrderArray: any[] = [];

  // variables for filter
  public filterBy: string = '';
  public userFilter: string = '';
  // public filterOn: boolean = false;
  public showList: boolean = false;
  public filterOptions = [
    { label: 'workOrderId', value: 'work_order_id' },
    { label: 'clientcreateFormInputClientName', value: 'legal_name' },
    { label: 'bin', value: 'bin_id' },
    { label: 'iotModalViewDeviceName', value: 'thing_name' },
  ];
  
  public WorkOrderStatus = WorkOrderStatus;
  public WorkOrderTypes = WorkOrderTypes;
  public workOrderStatusOptions = () =>
    WorkOrderStatus.map((status: any) => ({
      label: status.label,
      value: status.value,
    }));
  public workOrderTypeOptions = () =>
    WorkOrderTypes.map((type: any) => ({
      label: type.label,
      value: type.value,
    }));

  constructor(public theme: ThemeService,
              public distributors: DistributorsService,
              public cognitoService: CognitoService,
              public roleService: RoleService,
              public workOrderModalService: WorkOrderDashboardModalService,
              private systemMessageService: SystemMessageService,
              private localStorageService: LocalStorageService,
              private filter: FilterService,
              public workOrderService: WorkOrderService){

  }

  async ngOnInit() {
     // Call cognito to confirm valid user and get the user type of the current user
    await this.cognitoService.confirmValidUser();
    await this.cognitoService.getUserType();
    await this.roleService.getRoles();
    //Verifies that the current User is allowed to view this component
    this.cognitoService.getCurrentRole(
      [environment.users.role.administrator, environment.users.role.client],
      [environment.users.standardUser]
    ); //Role Check

    // Get the local storage message when user create a work order then come back to the list to send him if work order creation was successful or not
    const workOrderCreateMessage = this.localStorageService.getItem('workOrderCreate');
    if(workOrderCreateMessage){
      if(workOrderCreateMessage === 'success'){
        this.systemMessageService.selectRibbon('success', 'createOrderSuccess');
      }else if(workOrderCreateMessage === 'fail'){
        this.systemMessageService.selectRibbon('danger', 'createOrderError');
      }
      this.localStorageService.removeItem('workOrderCreate');
    }

    // Call role service to get the current user roles
    await this.roleService.getRoles();

    // Call the function to get all work orders by client ID
    await this.workOrderService.getAllEntityWorkOrders(this.cognitoService.clientId);

    this.originalWorkOrderArray = [...this.workOrderService.workOrdersArray];
    this.workOrderArray = [...this.originalWorkOrderArray];
    this.isLoading = false;
  }

  // Function that return column template for the display grid of the list
  getColumnStyle(): any{
    const numberOfColumn = this.ajustNumberOfColumns(this.getScreenWidth());
    if(numberOfColumn){
      if(this.workOrderService.workOrdersArray.length >= numberOfColumn){
        const gridColumns = `repeat(${numberOfColumn}, minmax(0, 325px))`;
        return {
          'grid-template-columns': gridColumns
        };
      }else{
        return {
          'display': `flex`,
          'justify-content': `center`,
          'margin': '0 -10px'
        };
      }
    }
  }

  // Function used to made a search in the list
  search(){
    // Check if there's a filterBy variable and set it to it's default value
    if(this.filterBy === ''){
      this.filterBy = 'thing_name';
    }

    this.workOrderArray = this.filter.search(this.userFilter, this.workOrderArray, this.originalWorkOrderArray, this.filterBy);
  }

  // Funciton called when user sort the array
  onSortChange(caller: string){
    // Switch the value of ascending or descending
    if(caller === 'switch'){
      if(this.ascDesc === 0){
        this.ascDesc = 1;
      }else{
        this.ascDesc = 0;
      }
    }

    // Avoid sortBy to have no value
    if(this.sortBy === ''){
      this.sortBy = 'work_order_id';
    }

    // Function that sort the list
    this.workOrderArray.sort((a, b) => {
      switch(this.sortBy){
        case 'work_order_id':
          return this.ascDesc === 0 ? b.work_order_id.localeCompare(a.work_order_id) : a.work_order_id.localeCompare(b.work_order_id);

        case 'work_order_type':
          return this.ascDesc === 0 ? b.work_order_type.localeCompare(a.work_order_type) : a.work_order_type.localeCompare(b.work_order_type);
      }
    });
  }

  // Funciton called when user change work order status
  changeWorkOrderStatus(workOrder: any){
    this.workOrderModalService.changeStatus(workOrder);
  }

  // Function called when user change the deadline date for the work order
  changeWorkOrderDeadlineDate(workOrder: any){
    this.workOrderModalService.changeDeadline(workOrder);
  }

  // Function called when user change the description of the work order
  changeWorkOrderDescription(workOrder: any){
    this.workOrderModalService.changeDescription(workOrder);
  }

  // Function called when user add comments on the work order
  changeWorkOrderComments(workOrder:any){
    // Get the user sub for inserting in work_order_comments table
    const userSub = this.cognitoService.userInfos.attributes.sub;
    // call function in the modal service
    this.workOrderModalService.addComment(workOrder, userSub);
  }

  // Function to get the current screen width
  getScreenWidth(): number {
    // Return the inner width of the window as the screen width
    return window.innerWidth;
  }

  // function called to adjust the number of column of the grid depbending of inner window width
  ajustNumberOfColumns(width: number): number | undefined{
    // Return the floor of the inner page width divided by 450 px as the width of the tile size
    return Math.floor((width / 350) * (90 / 100));
  }

   onFilterByStatusChange(){
    this.filterWorkOrders();
  }

   onFilterByTypeChange(){
    this.filterWorkOrders();
  }

  filterWorkOrders() {
    const statusValue = this.WorkOrderStatus.find(
      s => s.value === this.workOrderService.workOrderData.work_order_status)?.label || '';
    const typeValue = (this.getLabelFromValue(this.workOrderService.workOrderData.work_order_type) || '');
    if(!statusValue && !typeValue){
      this.workOrderArray = [...this.originalWorkOrderArray]
      return;
    }

    // Start from the original full list
    this.workOrderArray = this.originalWorkOrderArray.filter((order: any) => {
      const statusMatch = statusValue ? order.status.toLowerCase().includes(statusValue) : true;
      const typeMatch = typeValue ? order.work_order_type.includes(typeValue) : true;

      return statusMatch && typeMatch;
    });
  // // Set filterOn flag based on whether any filter is active
  // this.filterOn = !!(statusValue || typeValue);

  // // Optionally disable filtering if `showList` is false
  // if (!this.showList) {
  //   this.filterOn = false;
  // }
  }

 getLabelFromValue(value: any) {
  const options = [
    { value: 'M', label: '_maintenance' },
    { value: 'I', label: '_installation' },
    { value: 'C', label: '_collect' },
    { value: 'O', label: '_order' },
    { value: 'R', label: '_repair' },
    { value: 'E', label: '_emergency' },
    { value: 'D', label: '_decommission' }
  ];

  const found = options.find(option => option.value === value);
  return found ? found.label : null;
  }
}
